<template>
  <div class="video-share" data-grm-comp="RoomCallScreenShare"
    @dblclick="e => {
      if(!e.shiftKey) return;
      openSecondWindow();
    }"
  >
<!--
    <div
      class="screen-share-view"
      v-if="ifScreenShareView"
      :style="screenShareViewStyle"
    >
      <video webkit-playsinline playsinline autoplay ref="screenShareVideo"></video>
    </div>
-->

    <div class="share-title">
      <span> {{ roomUser.nickname || roomUser.username }} </span>
      <span>{{ $t("call.screenShare.sharing") }}</span>
    </div>

    <div v-if="hasEmceeRole() || isScreenShareUser" class="btn-quitShare" @click="onClickEndScreenShare">{{ $t("call.screenShare.quit.title") }}</div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";

import {GrmWebRTC} from "@/lib/gooroomee/webrtc/GrmWebRTC";

export default {
  name: 'RoomCallScreenShare',
  props: ['userId'],
  data() {
    return {
      stream : null
    }
  },
  watch: {
    stream: function(stream){
      this.$nextTick(() => {
        this.playScreenShareStream();
      });
    },
    isScreenShareUser: function(){
      this.$nextTick(() => {
        this.playScreenShareStream();
      });
    },

  },
  async created() {
    this._events = _.clone(_Events);
    this.$roomApi.addEventListeners(this._events, this)

    this.stream = await this.getScreenShareStream();
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._events)
    this.closeSecondWindow();
  },
  mounted() {
    this.playScreenShareStream();
  },
  computed: {
    ...mapGetters('room', [
      'room',
      'isRoomMode',
      'nextSchedule',
      'isShowSideWrap',
      'currentSchedule',
      'isRoomTypeWebinar',
    ]),
    ...mapGetters('user', [
      'me',
      'isMe',
      'hasSpeakerRole',
      'getRoomUser',
      'getScreenShareUser',
      'hasEmceeRole',
    ]),
    roomUser() {
      if(this.userId){
        return this.getRoomUser(this.userId);
      }else{
        return this.getScreenShareUser;
      }
    },
    isScreenShareUser() {
      // return this.me.userId === this.getScreenShareUser.userId;
      return this.isMe(this.roomUser);
    },
    ifScreenShareView() {
      return this.isRoomTypeWebinar
        ? !!this.stream
        : !this.isScreenShareUser && !!this.stream
    },
    screenShareViewStyle() {
      let style = {};

      if (!this.isRoomTypeWebinar) return style;
      
      if (this.isRoomMode('screenShare')) {
        if (!this.hasSpeakerRole()) {
          if (this.isShowSideWrap) {
            Object.assign(style, {
              width: '320px',
              height: '179.2px',
              position: 'fixed',
              top: '64px',
              right: 0,
              left: 'auto'
            });
          } else {
            Object.assign(style, {
              transform: 'translateX(100%)'
            });
          }
        }
      } else {
        if (!this.isShowSideWrap) {
          Object.assign(style, {
            transform: 'translateX(100%)'
          });
        }
      }

      return style;
    }
  },
  methods: {
    ...mapActions('room', [
      'startSchedule',
      'stopScreenShare',
      'changeScheduleState',
      'getScreenShareStream',
      'changeRoomMode',
    ]),

    playScreenShareStream(videoEl) {
      if(!this.stream || !this.$refs.screenShareVideo) return;

      if(videoEl === undefined){
        videoEl = this.$refs.screenShareVideo;
      }else if(!videoEl){
        return;
      }

      GrmWebRTC.attachMediaStream(videoEl, this.stream);
      videoEl.play();
    },
    onClickEndScreenShare() {
      this.$alert({
        title: this.$t('call.screenShare.quit.title'),
        text: this.$t('call.screenShare.quit.text'),
        ok: () => {
          this.stopScreenShare({
            userId: this.userId,
            roomMode: 'call',
          });
        }
      });
    },
    alertEndScreenShareWithNextSchedule() {
      const THIS = this;
      this.$alert({
        title: this.$t('call.screenShare.quit.title'),
        text: this.$t('call.screenShare.quit.confirm'),
        cancelText: this.$t('call.screenShare.quit.cancel'),
        okText: this.$t('call.screenShare.quit.ok'),
        isClose: true,
        cancel: async () => {
          await THIS.stopScreenShare();
        },
        ok: async () => {
          const currentSchedule = THIS.currentSchedule;
          const nextSchedule = THIS.nextSchedule;
          await THIS.startSchedule({ currentSchedule, nextSchedule });
        }
      });
    },
    closeSecondWindow() {
      if(!this.secondWindow) return;
      this.secondWindow.close();
    },
    openSecondWindow() {
      if(!this.isScreenShareUser){
        if(!this.stream || !this.$refs.screenShareVideo) return;
      }

      if(this.secondWindow){
        this.secondWindow.focus();
        return;
      }

      this.secondWindow = window.open('', '_grm_screenshare_second_window', 'menubar=no');
      if(!this.secondWindow){
        // 팝업 허용 필요
        return;
      }
      this.secondWindow.addEventListener('unload', e => {
        this.secondWindow = null;
      });

      this.secondWindow.document.title = this.$t('call.screenShare.sharingInfo', { '0' : this.roomUser.nickname });

      // window body 를 el 로 vue component 실행
      //

      // 임시 적용
      let video = document.createElement('video');
      video.muted = true;
      video.autoplay = true;
      Object.assign(video.style, {
        width: '100%', height: '100%',
      });
      this.secondWindow.document.body.appendChild(video);

      if(this.isScreenShareUser){
        this.getScreenShareStream().then(stream => {
          GrmWebRTC.attachMediaStream(video, stream || this.stream);
          video.play();
        })
      }else{
        this.playScreenShareStream(video);
      }
    }
  }
}

const _Events = {
  room_call_addstream_mixer_second: function(e){
    this.stream = e.data.stream;
  }
}
</script>

<style lang="scss" scoped>
.video-share {
  width: 100%;
  height: 100%;
  background-color: #394050;
  border-top: 2px solid #fff;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  text-align: center;
  background-color: transparent !important;

  .share-title {
    display: inline-block;
    min-width: 180px;
    padding: 0 12px;
    background-color: rgba(255, 255, 255, 0.8);
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    line-height: 24px;
    position: relative;
  }

  .btn-quitShare {
    background: #ff3819;
    border-radius: 0 0 0 6px;
    padding: 8px 10px 8px 12px;
    text-align: center;
    color: #fff;
    line-height: 1;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    font-size: 13px;
    pointer-events: auto;
  }
}

.screen-share-view {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  video {
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
}
</style>
